
export class InputHelper {
    /**
     * Maneja la entrada de dinero en un campo de texto.
     *
     * Esta función formatea la entrada del usuario para que represente un número decimal válido con hasta dos decimales.
     * - Elimina el símbolo de dólar si está presente.
     * - Reemplaza comas por puntos para decimales.
     * - Permite solo un punto decimal.
     * - Limita la cantidad de decimales a dos.
     * - Evita ceros a la izquierda innecesarios.
     * - Si el campo queda vacío, lo establece en "0".
     *
     * Ejemplos:
     * - Entrada: "$12,34" -> Salida: "12.34"
     * - Entrada: "00123.456" -> Salida: "123.45"
     * - Entrada: "0.99" -> Salida: "0.99"
     * - Entrada: "" -> Salida: "0"
     *
     * @param value El valor de entrada del campo de texto.
     * @returns El valor formateado como cadena que representa un número decimal válido.
     */
  static handleMoneyInput(value: string): string {

    // Elimina el símbolo de dólar si está presente
    let valorStr = value.replace("$", "")
    // Reemplaza comas por puntos para decimales
    valorStr.replace(",", ".");

    // Si borra el valor, se pone en 0
    if (valorStr === ''){
      valorStr = '0';
    }
    // Evita que se ponga un cero a la izquierda si intenta poner un numero mayor a 0
    else if (valorStr.startsWith("0") && valorStr.length > 1 && !valorStr.startsWith("0.")) {
      valorStr = valorStr.slice(1);
    }

    // Evita más de un punto decimal
    const puntos = valorStr.match(/\./g) || [];
    if (puntos.length > 1) {
      // Mantener solo el primer punto y eliminar los demás
      const primerPunto = valorStr.indexOf(".");
      valorStr = valorStr.slice(0, primerPunto + 1) + valorStr.slice(primerPunto + 1).replace(/\./g, "");
    }

    // Limita a 2 decimales si hay punto
    if (valorStr.includes(".")) {
      const [entero, decimal] = valorStr.split(".");
      if (decimal.length > 2) {
        valorStr = entero + "." + decimal.slice(0, 2);
      }
    }

    return valorStr;
  }
}